"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KansaReportHeader = void 0;
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _Header = _interopRequireDefault(require("../../components/Header"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const KansaReportHeader = props => {
  const {
    entries
  } = props;
  return /*#__PURE__*/_react.default.createElement(_Header.default, {
    itemList: [{
      labelId: _labelConsts.LABEL.KANSA_AUDIT_YEAR,
      value: entries.kansaTgtNendoNm
    }, {
      labelId: _labelConsts.LABEL.KANSA_AUDIT_THEME,
      value: entries.kansaThemeNm
    }, {
      labelId: _labelConsts.LABEL.KANSA_HI_KANSA_BUMON,
      value: entries.hikansabumon
    }, {
      labelId: _labelConsts.LABEL.KANSA_COMPLETE_COUNTS,
      value: entries.kansaKanryoKensu
    }, {
      labelId: _labelConsts.LABEL.KANSA_REPORT_LAST_UPD_USER,
      value: entries.lastUpdNm
    }, {
      labelId: _labelConsts.LABEL.KANSA_REPORT_LAST_UPD_DATE,
      value: entries.lastUpdDate
    }]
  });
};
exports.KansaReportHeader = KansaReportHeader;
var _default = exports.default = KansaReportHeader;